"use client";

import { Link } from "@/components/common/Link";
import { Facebook, Instagram, Linkedin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <footer id="footer" ref={ref} className={`bg-background border-t border-border py-6 transition-opacity duration-[var(--duration-medium)] ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {}
          <div className="flex-shrink-0">
            <Link to="/HomePage">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541714/img/prime_laundry_logo.png" alt="Prime Laundry" className="h-7" />
            </Link>
          </div>

          {}
          <div className="flex flex-col sm:flex-row items-center gap-6">
            {}
            <nav className="flex items-center gap-6">
              <Link to="/HomePage" className="text-sm text-foreground hover:text-primary-dark transition-colors duration-[var(--duration-fast)]">
                Home
              </Link>
              
            </nav>

            {}
            
          </div>
        </div>

        {}
        <div className="mt-6 pt-6 border-t border-border text-center">
          <div className="text-sm text-foreground">
            <p>Prime Laundry · Spartanburg, South Carolina</p>
            <p className="mt-1">A professionally developed laundromat concept focused on operational excellence</p>
          </div>
          <p className="text-sm text-muted-foreground mt-4">
            © {new Date().getFullYear()} Prime Laundry. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}